import createIcon from '../../createIcon';

/**
 * @component @name Tablet
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNEgzQzEuOSA0IDEgNC45IDEgNlYxOEMxIDE5LjEgMS45IDIwIDMgMjBIMjFDMjIuMSAyMCAyMi45OSAxOS4xIDIyLjk5IDE4TDIzIDZDMjMgNC45IDIyLjEgNCAyMSA0Wk0xOSAxOEg1VjZIMTlWMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Tablet = createIcon('Tablet', [
  [
    'path',
    {
      d: 'M21 4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H21C22.1 20 22.99 19.1 22.99 18L23 6C23 4.9 22.1 4 21 4ZM19 18H5V6H19V18Z',
      key: '1hy3bh',
    },
  ],
]);

export default Tablet;
